import React, { useEffect, useState } from 'react';

import Search from '../../elements/Search';
import Paginator from '../../elements/paginator';
import axios from '../../services/MyAxios';

import VouchersTable from './VouchersTable';

import Card from 'crm/elements/common/Card';

function VouchersList({ url, cardTitle, loading, setLoading }) {
    const [vouchers, setVouchers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [filter, setFilter] = useState('');

    function getVouchers(page = 1) {
        let requestUrl = url;
        requestUrl += `?page=${page}`;
        axios.get(requestUrl, { params: { filter } }).then((response) => {
            setVouchers(response.data.data);
            setCurrentPage(response.data.current_page);
            setLastPage(response.data.last_page);
            setLoading(false);
        });
    }

    useEffect(() => {
        getVouchers();
    }, [filter]);

    useEffect(() => {
        if (loading) {
            getVouchers();
        }
    }, [loading]);

    useEffect(() => {
        if (currentPage > lastPage) {
            // useful when deleting last item
            getVouchers(lastPage);
        }
    }, [currentPage, lastPage]);

    return (
        <Card title={cardTitle}>
            <Search filterTable={(value) => setFilter(value)} />
            <div className="table-responsive">
                <VouchersTable vouchers={vouchers} />
                <Paginator currentPage={currentPage} lastPage={lastPage} onPageChange={getVouchers} />
            </div>
        </Card>
    );
}

export default VouchersList;
